/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Success_UpdatedInputs */

const he_posts_success_updated = /** @type {(inputs: Posts_Success_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פוסט עודכן`)
};

const en_posts_success_updated = /** @type {(inputs: Posts_Success_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post updated`)
};

/**
* | output |
* | --- |
* | "Post updated" |
*
* @param {Posts_Success_UpdatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_success_updated = /** @type {((inputs?: Posts_Success_UpdatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Success_UpdatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_success_updated(inputs)
	return en_posts_success_updated(inputs)
});